import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Layout Components
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";

// Pages
import { HomePage } from "./pages/HomePage";
import { CountryDetailPage } from "./pages/CountryDetailPage";
import { SessionsPage } from "./pages/SessionsPage";
import { SessionDetailPage } from "./pages/SessionDetailPage";
import { BookCallPage } from "./pages/BookCallPage";
import { ProfileEvaluationPage } from "./pages/ProfileEvaluationPage";
import { ThankYouPage } from "./pages/ThankYouPage";
import { AdminPage } from "./pages/AdminPage";

// Layout wrapper for public pages
const PublicLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
          <Route path="/country/:code" element={<PublicLayout><CountryDetailPage /></PublicLayout>} />
          <Route path="/sessions" element={<PublicLayout><SessionsPage /></PublicLayout>} />
          <Route path="/session/:sessionId" element={<PublicLayout><SessionDetailPage /></PublicLayout>} />
          <Route path="/book-call" element={<PublicLayout><BookCallPage /></PublicLayout>} />
          <Route path="/profile-evaluation" element={<PublicLayout><ProfileEvaluationPage /></PublicLayout>} />
          <Route path="/thank-you" element={<PublicLayout><ThankYouPage /></PublicLayout>} />
          
          {/* Admin Route (no layout) */}
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
